import paQuickQuoteView from 'text!../views/pa-quick-quote.html';
import PaQuickQuoteCtrl from '../controllers/PaQuickQuoteCtrl';
import MapUtil from 'gw-portals-util-js/MapUtil';

export default (function (RootStates) {
    var parentState = RootStates.quote_bind;
    /* LOAD GOOGLE MAPS */
    var loadScript = function loadScript(src, onLoad) {
        var script = document.createElement('script');
        script.onload = onLoad;
        script.async = true;
        script.src = src;
        document.head.appendChild(script);
    };
    var protocol = document.location.protocol === 'https:' ? 'https' : 'http';

    var googleMapsApiSrc = protocol + '://maps.googleapis.com/maps/api/js?key=' + MapUtil.getApiKey() + '&libraries=geometry,places';

    loadScript(googleMapsApiSrc, function () {/* no-op */
    });
    return {
        paquickQuote: {
            parent: parentState,
            url: '/paquickQuote',
            controller: PaQuickQuoteCtrl,
            template: paQuickQuoteView,
            data: {
                trackingUrl: '/pa-quick-quote/PersonalAuto'
            }
        }
    };
});


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/quoteandbind/quickquote/pa/config/RouteConfig.js
// module id = 2183
// module chunks = 0